//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import XLSX from 'xlsx';
export default {
  name: 'ImportExcel',
  props: {
    columnNumber: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: ''
    },
    distinguish: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      rowNumber: 1
    };
  },
  methods: {
    btnClick: function btnClick() {
      // 点击事件
      document.querySelector('.input-file').click();
    },
    exportData: function exportData(event) {
      if (!event.currentTarget.files.length) {
        return;
      }
      var that = this;
      // 拿取文件对象
      var f = event.currentTarget.files[0];
      // 用FileReader来读取
      var reader = new FileReader();
      // 重写FileReader上的readAsBinaryString方法
      FileReader.prototype.readAsBinaryString = function (f) {
        var binary = '';
        var wb; // 读取完成的数据
        var outdata; // 你需要的数据
        var reader = new FileReader();
        reader.onload = function () {
          // 读取成Uint8Array，再转换为Unicode编码（Unicode占两个字节）
          var bytes = new Uint8Array(reader.result);
          var length = bytes.byteLength;
          for (var i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          // 接下来就是xlsx了，具体可看api
          wb = XLSX.read(binary, {
            type: 'binary',
            cellDates: true
          });
          outdata = XLSX.utils.sheet_to_csv(wb.Sheets[wb.SheetNames[0]]);
          var arrData = outdata.split('\n');
          var arrRes = [];
          for (var _i = that.columnNumber; _i < arrData.length; _i++) {
            if (arrData[_i] === '') {
              continue;
            } else {
              arrRes.push(arrData[_i].split(','));
            }
          }
          document.getElementById('referenceUpload').value = null;
          // 自定义方法向父组件传递数据
          that.$emit('importExcelData', arrRes);
        };
        reader.readAsArrayBuffer(f);
      };
      reader.readAsBinaryString(f);
    }
  }
};